import { Browser } from './browser';

export function isSmartTV() {
  const userAgent = Browser.userAgent.toLowerCase();

  return userAgent.includes('tizen') || userAgent.includes('smart-tv');
}
